import axios from 'axios';
import { Ticket } from '../../application/models/ticket';
import { UserCentral } from '../../application/models/userCentral';
import config from "./../../application/common/config";

// eslint-disable-next-line
export const login = async (casTicket: Ticket): Promise<UserCentral | null> => {
  try {
    // console.log("Sending login request with payload", casTicket);
    const response = await axios.post(`${config.SERVICE_URL_TASK}/system/CAS/login`, casTicket); 
    // console.log(window.location.hostname);
    return JSON.parse(response.data);
  } catch (error) {
    console.error(error);
    return null;
  }
};

// eslint-disable-next-line
export const refresh = async (currentUserCentral: UserCentral): Promise<UserCentral | null> => {
  try {
     const response = await axios.post(`${config.SERVICE_URL_TASK}/system/CAS/refresh`, currentUserCentral);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

